import { $Q } from "./query-selector";

export function setOverflow(type, element){
  $Q(element).style.overflow = type;
};
